import type { Tone } from '@constants/tones';
import type { UploadState } from '@lib/hooks';
import { UPLOAD_STATUS as T } from '@locales/id/messages';
import { Chip } from './Chip';

const TONE: Record<UploadState['status'], Tone> = { preparing: 'blue', uploading: 'blue', waiting: 'amber', retrying: 'amber', done: 'green', failed: 'amber' };

/** One file's upload state as a chip (progress in words for screen readers too); `photo` names it a photo. */
export function UploadStatusChip({ state, photo }: { state: UploadState; photo?: boolean }) {
  const text =
    state.status === 'preparing'
      ? T.preparing(photo ? T.photo : T.file)
      : state.status === 'uploading'
        ? T.uploading(Math.round(state.progress * 100))
        : T[state.status];
  return <Chip tone={TONE[state.status]}>{text}</Chip>;
}
